export const navbarStyles = {
  nav: 'mx-auto max-w-7xl',
  userMenu: 'relative rounded-md p-2 text-primary',
  navItemsLayout: 'flex h-16 items-center px-2 w-full',
}
